import axios from "axios";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { confirmAlert } from "react-confirm-alert";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import ReUseableAuditionHeaderTitle from "../../Reuseable/ReUseableAuditionHeaderTitle";
import Button from "../Event/RoundVideoResultFour/Component/Button";
import style2 from "../Event/RoundVideoResultFour/CSS/RoundVideoResult.module.css";
import Card from "../Event/RoundVideoResultThree/Component/Card";
import "./AuditionRounds.css";
import AuditionJudgeTotalVideo from "./AuditonJudgeTotalVideo";
import JudgeMarkTable from "./JudgeMarkTable";

const AuditionRoundJudgeAssessmentResult = ({ tabActiveRound }) => {
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    // <img src={LeftArrow} alt="prevArrow" {...props} />
    <FaArrowLeft {...props} />
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <FaArrowRight {...props} />
  );

  const [auditionRoundInfo, setAuditionRoundInfo] = useState([]);
  const [videoType, setVideoType] = useState("general");
  const [activeRound, setActiveRound] = React.useState(0);
  const [roundBasedVideos, setRoundBasedVideos] = React.useState([]);
  const [event, setEvent] = useState({});
  const [rounds, setRounds] = useState([]);
  const { slug } = useParams();
  const [auditionParticipants, setAuditionParticipants] = React.useState([]);
  const [isAbleToMerge, setIsAbleToMergeVideo] = useState([]);

  const [count, setCount] = useState(1);
  const [filterNumber, setFilterNumber] = useState(1);
  const [filterType, setFilterType] = useState("");
  const [loading, setLoading] = useState(true);
  const [step, setStep] = React.useState(1);
  const [roundMarkTrackings, setRoundMarkTrackings] = React.useState({});

  const getRoundAndVideos = () => {
    axios
      .get(`/api/audition-admin/audition/judgeMark/${event?.id}/${activeRound}`)
      .then((res) => {
        if (res.data?.status === 200) {
          setRoundBasedVideos(res.data?.roundBasedAuditionUploadVideos);
          setAuditionRoundInfo(res.data?.auditionRoundInfo);
          setAuditionParticipants(res.data?.participants);
          setIsAbleToMergeVideo(res.data.ableToMargeVideos);
        }
      });
  };

  const fetchAuditionDetails = () => {
    axios.get(`/api/audition-admin/audition-event/with-rounds/${slug}`).then((res) => {
      if (res.data?.status === 200) {
        setEvent(res.data?.event);
        setActiveRound(
          res.data?.event.active_round_info_id === tabActiveRound
            ? res.data?.event.active_round_info_id
            : tabActiveRound
        );
        //if error then add info
        setRounds(res.data?.event?.audition_round);
      }
    });
  };

  const handleMergeVideo = () => {
    axios
      .get(
        `/api/audition-admin/audition/auditionRoundVideoMerge/${event?.id}/${activeRound}`
      )
      .then((res) => {
        if (res.data?.status === 200) {
          swal("Success", res.data?.message, "success");
          getRoundAndVideos();
        }
      });
  };

  useEffect(() => {
    getRoundAndVideos();
  }, [activeRound]);

  useEffect(() => {
    fetchAuditionDetails();
  }, [slug]);
  useEffect(() => {
    fetchAuditionDetails();
  }, [tabActiveRound]);

  // Process Result

  const handleCountChange = (e) => {
    if (e.target.value > 100 || e.target.value < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
      setCount(1);
    } else {
      setCount(Number(e.target.value));
    }
  };
  const handleFilterNumberChange = (e) => {
    if (e.target.value < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
      setFilterNumber(1);
    } else {
      setFilterNumber(Number(e.target.value));
    }
  };
  const viewResultByPercentage = () => {
    setFilterType("percentage");
    if (Number(count) > 100 || Number(count) < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByPercentage/${event?.id}/${activeRound}/${count}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.percentageBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.percentageBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const viewResultByFilterNumber = () => {
    setFilterType("number");
    if (Number(filterNumber) < 0) {
      swal("Opps...", "Sorry input field should not short then 0", "error");
    } else {
      axios
        .get(
          `/api/audition-admin/audition/singleAuditionRoundVideoResultByFilterNumber/${event?.id}/${activeRound}/${filterNumber}/${videoType}`
        )
        .then((res) => {
          if (res.data?.status === 200) {
            setRoundMarkTrackings(res.data?.filterNumberBaseRoundMarkTrackings);
            swal(
              "Success",
              "Found " +
                res.data?.filterNumberBaseRoundMarkTrackings?.length +
                " user for the next round",
              "success"
            );
          }
        });
    }
  };

  const userSendToManager = () => {
    const fData = new FormData();
    fData.append("percentage_range", count);
    fData.append("filter_number", filterNumber);
    fData.append("filter_type", filterType);
    fData.append("audition_id", event.id);
    fData.append("round_info_id", activeRound);
    fData.append("type", videoType);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/audition-admin/audition/roundResultSendToManager`, fData)
        .then((res) => {
          if (res.data?.status == 200) {
            swal("success", res.data?.message, "success");
            setLoading(true);
            getRoundAndVideos();
          }
        });
    });
  };

  function increment() {
    setCount(function (prevCount) {
      if (prevCount < 100) {
        return (prevCount += 1);
      } else {
        return (prevCount = 100);
      }
    });
  }

  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }
  function incrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      return (prevFilterNumber += 1);
    });
  }

  function decrementNumber() {
    setFilterNumber(function (prevFilterNumber) {
      if (prevFilterNumber > 0) {
        return (prevFilterNumber -= 1);
      } else {
        return (prevFilterNumber = 0);
      }
    });
  }

  const tableHead = [
    "Name",
    "Email",
    "Judge Mark",
    "User Vote",
    "Mark (Final)",
  ];

  // Confirm Alert

  function makeConfirm() {
    confirmAlert({
      title: "Please Confirm Carefully",
      message: "If once submit, you cant't undo !",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleMergeVideo(),
        },
        {
          label: "No",
          // onClick: () => alert("Click No"),
        },
      ],
    });
  }

  return (
    <>
      <>
        <div className="container">
          <div className="card card-bg head-line mt-2 mb-2">
            <div className="text-light">
              <h4
                style={{ color: "rgb(253 224 71)" }}
                className="mx-3 fw-bolder text-center p-2"
              >
                Total Videos ({roundBasedVideos && roundBasedVideos.length})
              </h4>
            </div>
          </div>

          <div className="my-3">
            <AuditionJudgeTotalVideo data={roundBasedVideos} />
          </div>
        </div>
        <br />
        <div className="container">
          <JudgeMarkTable
            data={auditionParticipants}
            tableHead={tableHead}
            videoType={videoType}
            auditionRoundInfo={auditionRoundInfo}
          />

          <div className="text-center">
            {isAbleToMerge?.length <= 0 ? (
              <>
                <div>
                  <ReUseableAuditionHeaderTitle
                    isPrimary={false}
                    title={
                      "Round " +
                      auditionRoundInfo?.round_num +
                      " - Make result for next round"
                    }
                  />

                  <div className="row mx-1 my-3 card-bg justify-content-center py-4">
                    <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                      <div className="card-bg px-3">
                        <b className="text-light">Take</b>
                      </div>
                    </div>
                    <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                      <div className="d-flex card-bg px-3 justify-content-around">
                        <button
                          onClick={decrement}
                          className="btn btnDecrement bold"
                        >
                          <i class="fa-solid fa-minus"></i>
                        </button>
                        <input
                          type="number"
                          value={count}
                          onChange={(e) => handleCountChange(e)}
                          className="text-center border-0 from-control bg-black fw-bold btnInput"
                        />
                        <button
                          onClick={increment}
                          className="btn btnIncrement bold"
                        >
                          <i class="fa-solid fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                      <div className="card-bg px-3">
                        <b className="text-light">
                          % mark gained user for the next round
                        </b>
                      </div>
                    </div>
                    <Button
                      text={"View Result"}
                      onClick={viewResultByPercentage}
                    />
                  </div>
                </div>

                <div>
                  <ReUseableAuditionHeaderTitle
                    isPrimary={false}
                    title={
                      "Round " +
                      auditionRoundInfo?.round_num +
                      " - Make result for next round"
                    }
                  />

                  <div className="row mx-1 my-3 card-bg justify-content-center py-4">
                    <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                      <div className="card-bg px-3">
                        <b className="text-light">Take</b>
                      </div>
                    </div>
                    <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                      <div className="d-flex card-bg px-3 justify-content-around">
                        <button
                          onClick={decrementNumber}
                          className="btn btnDecrement bold"
                        >
                          <i class="fa-solid fa-minus"></i>
                        </button>
                        <input
                          type="number"
                          value={filterNumber}
                          onChange={(e) => handleFilterNumberChange(e)}
                          className="text-center border-0 from-control bg-black fw-bold btnInput"
                        />
                        <button
                          onClick={incrementNumber}
                          className="btn btnIncrement bold"
                        >
                          <i class="fa-solid fa-plus"></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
                      <div className="card-bg px-3">
                        <b className="text-light">Take top user by mark</b>
                      </div>
                    </div>
                    <Button
                      text={"View Result"}
                      onClick={viewResultByFilterNumber}
                    />
                  </div>
                </div>

                {roundMarkTrackings.length > 0 ? (
                  <>
                    <div className={style2.section}>
                      <Card
                        number={auditionParticipants.length}
                        title={"Total User"}
                        cardText={"User"}
                      />
                      <Card
                        number={roundMarkTrackings.length}
                        title={"Qualify For The Next Round"}
                        cardText={"User"}
                      />
                      <Card
                        number={
                          auditionParticipants.length -
                          roundMarkTrackings.length
                        }
                        title={"Disqualify For This Round"}
                        cardText={"User"}
                      />
                    </div>

                    {videoType == "general" ? (
                      <>
                        {Number(auditionRoundInfo?.manager_status) != 0 ? (
                          <Button text={"Already Sent To Manager"} />
                        ) : (
                          <Button
                            text={"Approved Request For Manager"}
                            onClick={userSendToManager}
                          />
                        )}
                      </>
                    ) : (
                      <>
                        {Number(auditionRoundInfo?.appeal_manager_status) !=
                        0 ? (
                          <Button text={"Already Sent To Manager"} />
                        ) : (
                          <Button
                            text={"Approved Request For Manager"}
                            onClick={userSendToManager}
                          />
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <button className="btn btn-warning" onClick={makeConfirm}>
                Merge Result
              </button>
            )}
          </div>
        </div>
      </>
    </>
  );
};

export default AuditionRoundJudgeAssessmentResult;
